import { connect } from "react-redux";
// import { ILocation } from "../models/ILocation";
import { ActuatorChannel, IActuator } from "../models/types";
import { getActuatorStatus, toggleRelay } from "../actions/actuatorActions";
import { useEffect, useState } from "react";
import UIButton from "./utilities/UIButton";
// import { actuators } from "../reducers/actuatorReducer";

interface Props {
    dispatch: Function;
    actuator: IActuator;
}

const Actuator: React.FC<Props> = ({ dispatch, actuator }) => {

    function handleClick(chan: ActuatorChannel) {
        toggleRelay(actuator, chan)
            .then(res => actuator = (res as IActuator))//TODO call the parent componens
            .catch(err => console.error(err));
    }

    function Channel({ chan }: { chan: ActuatorChannel }) {
        let buttonText = '';
        if (chan.state === undefined) {
            return null;
        }
        // if (chan.state !== undefined) {
            switch (chan.state.toLowerCase()) {
                case 'on':
                    buttonText = 'OFF';
                    break;
                case 'off':
                    buttonText = 'ON';
                    break;
            }
        // }
        let hideButton = (buttonText === '');
        return (
            <>
                <div style={{ display: "flex", flexDirection: "row", alignItems: 'flex-start' }}>
                    <div style={{ margin: '10px' }}>{chan.name}</div>
                    <div style={{ margin: '10px' }}>{chan.state.toLowerCase()}</div>
                    <div style={{ margin: '10px' }}>
                        <button style={{ width: '50px' }}
                            onClick={() => handleClick(chan)} hidden={hideButton}>
                            {buttonText}
                        </button>
                    </div>
                </div >
            </>
        )
    }

    function Channels() {
        let channels: ActuatorChannel[] = [];
        if (actuator.custom_values) {
            if (actuator.custom_values[actuator.driver]) {
                Object.entries(actuator.custom_values[actuator.driver]).forEach(([k, v]) => {
                    let chan = v as ActuatorChannel;
                    channels.push({ code: k, name: chan.name, state: chan.state });
                });
                return (
                    <>
                        {channels.map((e, key: number) =>
                            <Channel chan={e} key={key} />)
                        }
                    </>
                );
            }
        }
        return (
            <>
                <div style={{ margin: '10px' }}>No channels</div>
            </>
        )
    }

    return (
        <>
            <div className="bg-primary" style={{
                borderRadius: '12px',
            }}>
                <div style={{ color: "white", margin: '10px' }}>{actuator.name}</div>
                <Channels />
            </div>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    // location: state.location,
    // actuators: state.actuators.actuators,
});

export default connect(mapStateToProps)(Actuator);